import { Message, MessageLanguageSpecificContent } from '../../state/types';

export const getId = (messageId: Message['id'], language: MessageLanguageSpecificContent['content']['language']) =>
  `${messageId}-${language}`;
